import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';
import { DataAccessProductsComponent } from './data-access-products/data-access-products.component';
import { DataAccessComponent } from './data-access.component';
import { DataAccessWrapperDialogComponent } from './data-access-wrapper-dialog.component';

@NgModule({
  declarations: [
    DataAccessProductsComponent,
    DataAccessComponent,
    DataAccessWrapperDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule
  ]
})
export class DataAccessModule { }
